import { css } from "@emotion/react";
import { Dropdown } from "primereact/dropdown";
import { BotListDropdown } from "./sidebar";

export interface FiltersBarProps {
  status: string;
  bot: number | null;
  botsList?: BotListDropdown[];
  onStatusChange: (status: string) => void;
  onBotsListChange: (botsList: number | null) => void;
}

const FiltersBar = ({
  status,
  bot,
  botsList,
  onStatusChange,
  onBotsListChange
}: FiltersBarProps) => (
  <div
    css={css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      border-bottom: 1px solid #282d35;
    `}
  >
    <div
      css={css`
        width: 48%;
        padding: 8px 0;
      `}
    >
      <Dropdown
        css={css`
          width: 100%;
          height: 32px;
          padding: 0 3px;
          border: none;
          background-color: #2f343d;
          display: flex;
          align-items: center;

          .p-dropdown-label {
            color: #6e6b7b;
            padding: 4px 0 !important;
            line-height: 1.2;
            display: flex;
            align-items: center;
          }

          .p-dropdown-trigger {
            width: 24px;
          }

          &:not(.p-disabled):hover {
            border-color: #2f343d;
          }
        `}
        placeholder="Todas as salas"
        options={[
          {
            label: "Todas as salas",
            value: ""
          },
          {
            label: "Abertas",
            value: "OPEN"
          },
          {
            label: "Fechadas",
            value: "CLOSED"
          }
        ]}
        optionLabel="label"
        optionValue="value"
        value={status}
        onChange={(e) => onStatusChange(e.value)}
      />
    </div>

    <div
      css={css`
        height: 100%;
        width: 1px;
        background: #282d35;
      `}
    />

    <div
      css={css`
        width: 48%;
        padding: 8px 0;
      `}
    >
      <Dropdown
        css={css`
          width: 100%;
          height: 32px;
          padding: 0 3px;
          border: none;
          background-color: #2f343d;
          display: flex;
          align-items: center;

          .p-dropdown-label {
            color: #6e6b7b;
            padding: 4px 0 !important;
            line-height: 1.2;
            display: flex;
            align-items: center;
          }

          .p-dropdown-trigger {
            width: 24px;
          }

          &:not(.p-disabled):hover {
            border-color: #2f343d;
          }
        `}
        placeholder="Robôs"
        options={botsList}
        optionLabel="label"
        optionValue="value"
        value={bot}
        onChange={(e) => onBotsListChange(e.value)}
        showClear
      />
    </div>
  </div>
);

export default FiltersBar;
